import { getTvObject, tv } from '@costar-ui/cosmos';

var logoTV = getTvObject({
  base: [''],
  //base = common styles
  variants: {
    size: {
      xs: ['w-12', 'h-12', 'min-w-12'],
      // 48px
      sm: ['w-[5.625rem]', 'h-[5.625rem]', 'min-w-[5.625rem]'],
      // 90px
      md: ['w-[7rem]', 'h-[7rem]', 'min-w-[7rem]'],
      // 112px
      lg: ['w-[10rem]', 'h-auto', 'min-w-[10rem]'] // 160px
    }
  }
});
var base = {
  base: tv(logoTV)
};
var logoStyles = {
  base: base
};

export { logoStyles, logoTV };
//# sourceMappingURL=logo.styles.esm.js.map
